// extracted by mini-css-extract-plugin
module.exports = {"selected":"Card_selected__SyQC0"};